export class ISSUANCE_INVESTOR {
    constructor(
        public BID_ID: number,
        public IDTY_NO: string,
        public INV_ID: number,
        public INV_NAME: string,
        public SERIES_NAME: string,
        public SUBREG_NAME: string,
        public SEC_REK_NO: string,
        public BANK_REK_NO: string,
        public ALT_AMT: number,
        public BID_AMT: number,
        public STAT_ISSUE: string,
        public ATTACHMENT: string,
        public CHECKED: boolean,
        public BID_DATE: string,
        public SELLING_AGENT: string,
        public SID: string,
        public CD_PRIORITY: string,
        public CHECKER: string,
        public MAKER: string,
        
    ) { }
}

export class ISSUE {
    constructor(
        public BID_ID: number,
        public INV_ACCT_ID: number,
        public SEC_ACCT_ID: number,
        public INV_ACCT_NO: number,
        public SEC_ACCT_NO: number,
        public ALT_AMT: number,
        public BID_AMT: number,
        public CREATED_BY: number,
        public ATTACHMENT: string,
        public GROUP_ID: number,
        public CD_JN_WAKAF: string,
        public AIW: string,
    ) { }
}

export class BIDS {
    constructor(
        public BID_ID: number,
        public SS_ID: number,        
        public BID_AMT: number,
        public ALT_AMT: number,
        public BID_DATE:Date,          
        public CG_STATUS: number,
        public CD_STATUS:string,   
        public CG_PRIORITY: number,
        public CD_PRIORITY:string,
        public D_CREATED:Date,
    ) { }
}


// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/models/Issuance.ts